namespace Matrix.Data.Repositories {
    export interface TestGroupRunResponse extends Serenity.ServiceResponse {
    }
}
